import { render, staticRenderFns } from "./xqDialog.vue?vue&type=template&id=2554cab2&"
import script from "./xqDialog.vue?vue&type=script&lang=js&"
export * from "./xqDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports